"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.clyde.description': 'Brytyjczyk z mocą, niuansami i humorem.',
};
